import { axiosBilling } from "./axios-helper";

export const billingService = {
    getAllDocuments,
    getDocumentSettings,
    getInvoiceData,
    getCreditNoteData,
    getAllDocumentsForShopify,
};

function getAllDocuments(externalId, integration, shopIdentifier) {
    return axiosBilling().post("/billing/documents", { externalId, integration, shopIdentifier });
}

function getDocumentSettings(externalUUID, orderDataUUID, wrapperType, originalId) {
    return axiosBilling().get(
        "/billing/settings/" +
            externalUUID +
            "?type=" +
            wrapperType +
            (orderDataUUID ? "&data=" + orderDataUUID : "") +
            (originalId ? "&originalId=" + originalId : "")
    );
}

// Template fetch invoices data to display invoice
function getInvoiceData(uuid) {
    return axiosBilling().get("/billing/data/i/" + uuid);
}

// Template fetch creditnotes data to display creditnotes
function getCreditNoteData(uuid, refundId) {
    return axiosBilling().get("/billing/data/cn/" + uuid + "/" + refundId);
}

function getAllDocumentsForShopify(shopId, orderId) {
    return axiosBilling().get("/billing/shopify/documents/" + shopId + "/" + orderId);
}
